import apiClient from "../../../../../services/apiClient";


export const changeDate = async (data, callback, err) => {

    const link='child_date_from';

    const ret = await apiClient.post(link, data);

    if(ret.data) return ret.data;

    return ret.error || null;

};

export const childrenAPI = {
  getChildrenByCertificate: async (certificateNumber) => {
    const link = `children_kg_short?birth_certificate_number=${certificateNumber}`;

    const ret = await apiClient.get(link);


    if(ret.data) return { success: true, data: ret.data };

    return { success: false, error: ret?.error?.message || '' };
      
  }
};


